export const MASTER_MEALS_ONLY = true;
